import React, { memo } from 'react'
import { useParams } from 'react-router-dom'
import { useCarrierExtendedInformation } from '../GeneralInformation/CarrierSummary/components/ExtendedCarrierScorecard/hooks/useCarrierExtendedInformation'
import CarrierSummaryCard from './components/CarrierSummaryCard/CarrierSummaryCard'

export interface ISidebarProps {}

const CarrierProfileSidebar = memo<ISidebarProps>(() => {
  const { id } = useParams<{ id: string }>()

  const { data: extendedCarrierData } = useCarrierExtendedInformation(id)
  const {
    bounceRate,
    carrierId,
    carrierName,
    carrierScore,
    dotNumber,
    hqValue,
    mcNumber,
    onTimeRate,
    rate,
    shipmentsCount,
    status,
    trackingRate,
  } = extendedCarrierData

  return (
    <CarrierSummaryCard
      carrierName={carrierName}
      mcNumber={mcNumber}
      dotNumber={dotNumber}
      hqValue={hqValue}
      status={status}
      rate={rate}
      bounceRate={bounceRate}
      onTimeRate={onTimeRate}
      trackingRate={trackingRate}
      carrierScore={carrierScore}
      carrierId={carrierId}
      shipmentsCount={shipmentsCount}
    />
  )
})

export default CarrierProfileSidebar
